import { render } from "./InputReadersSuffix.vue?vue&type=template&id=ccb8f450"
import script from "./InputReadersSuffix.vue?vue&type=script&lang=ts"
export * from "./InputReadersSuffix.vue?vue&type=script&lang=ts"
script.render = render

export default script